import styled from '@emotion/styled';
import { colors, spacing, typography } from 'component-library';
import { maxmq } from '../../assets/styles/breakpoints';

export const DropDownMenuWrapper = styled.div`
  position: relative;
`;

export const NameDiv = styled.div`
  text-align: center;
`;

export const StyledMenuItem = styled.div<{ isActive?: boolean }>`
  padding: 0;
  margin: ${spacing.tiny} ${spacing.xxsmall};

  &:hover {
    background-color: ${colors.background.grey};
    border-radius: 4px;
    svg {
      color: ${colors.primary.blue};
    }
  }
`;

export const DropDownMenuInnerWrapper = styled.div`
  z-index: 500;
  box-sizing: border-box;
  position: absolute;
  top: 31px;
  right: 0px;
  background-color: ${colors.base.white};
  min-width: 300px;
  width: fit-content;
  max-width: 100vw;
  color: ${colors.base.black};
  border: 1px solid ${colors.monochrome.grey10};
  /* Dropdown shadow */

  box-shadow: 0px 15px 40px rgba(51, 51, 51, 0.15);
  border-radius: 4px;
  ${maxmq[0]} {
    min-width: 100vw;
    right: -24px;
  }
`;

export const HorizontalDivider = styled.div`
  height: 1px;
  background-color: ${colors.monochrome.grey20};
  width: 100%;
  margin: ${spacing.xxsmall} 0;
`;

export const UserInfo = styled.div`
  padding: ${spacing.xsmall} ${spacing.xsmall} ${spacing.xmsmall} ${spacing.xsmall};
  border-bottom: 1px solid ${colors.monochrome.grey20};
  background-color: ${colors.background.grey};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing.xmsmall};
`;

export const Name = styled.p`
  ${typography.body.largeBold};
  margin: 0;
`;

export const Email = styled.p`
  color: ${colors.primary.grey};
  ${typography.body.small};
`;
export const BottomPart = styled.div`
  padding: ${spacing.xxsmall};
  display: flex;
  flex-direction: column;
`;

export const LogoutButton = styled.button`
  font-family: inherit;
  ${typography.other.subMenuLabel};
  gap: ${spacing.xxsmall};
  justify-content: flex-start;
  align-items: center;

  margin: 0;
  color: ${colors.base.black};
  height: 40px;
  padding: ${spacing.xmsmall} ${spacing.xxsmall};
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: ${colors.background.grey};
    border-radius: 4px;
    color: ${colors.primary.blue} !important;
  }
`;

export const Link = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacing.xxsmall};
  font-size: 1rem;
  line-height: 24px;
  color: ${colors.base.black};
  text-decoration: none;
  margin: 0;
  height: 40px;
  padding: ${spacing.xmsmall} ${spacing.xxsmall};
  cursor: pointer;
  &:hover {
    border-radius: 4px;
    color: ${colors.primary.blue};
  }
`;

export const LinkWrapper = styled.div`
  &:hover {
    background-color: ${colors.background.grey};
    border-radius: 4px;
    color: ${colors.primary.blue} !important;
  }
`;
